export default [
    {
        name: 'integracao-endereco',
        path: 'endereco',
        redirect: 'endereco/index',
        component: () => import(/* webpackChunkName: 'integracao-endereco' */ '@/views/integracao/endereco/Index'),
        children: [
            {
                meta: {title: 'Lista de integrações de endereço'},
                name: 'integracao-endereco-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'integracao-endereco' */ '@/views/integracao/endereco/List.vue'),
            },
            {
                meta: {title: 'Integração de endereço'},
                name: 'integracao-endereco-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'integracao-endereco' */ '@/views/integracao/endereco/Form.vue'),
            },
        ],
    },
]